import Script from "next/script";

export default function PortOneScript () {
    return (
        <>
            <Script src="https://static.portone.cloud/portone.js" strategy="lazyOnload" />
        </>
    );
}
